import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, inject } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { ByocMissionService } from './service/mission.service';
import { OpenClose, PopupBaseComponent } from '@app/shared/popup';
import { ByocMissionPopupService } from './service/popup.service';

@Component({
    selector: 'app-byoc-mission',
    templateUrl: './mission.component.html',
    styleUrls: ['./mission.component.scss'],
    providers: [ByocMissionService],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [OpenClose],
    standalone: false
})
export class ByocMissionComponent extends PopupBaseComponent implements OnInit, OnDestroy {
    private byocMissionService = inject(ByocMissionService);
    private byocMissionPopupService = inject(ByocMissionPopupService);
    private closingSubject = new Subject<string>();
    private subscriptions = new Subscription();

    closeEvent$ = this.closingSubject.asObservable();

    ngOnInit() {
        this.setDataToServices();
        this.byocMissionService.step = 'general';
        this.subscriptions.add(
            this.byocMissionService.closeEvent.subscribe((reason: string) => {
                this.close(reason);
                this.byocMissionPopupService.onClose(reason, reason);
            }),
        );
    }

    ngOnDestroy() {
        this.byocMissionService.destroy();
        this.subscriptions.unsubscribe();
    }

    /**
     * Set passed parent data
     */
    setDataToServices(): void {
        const data = <any>this.data;
        if (typeof data.isSubmodal !== 'undefined') {
            this.byocMissionService.isSubmodal = data.isSubmodal;
        }

        // set missionId
        if (data.courseId) {
            this.byocMissionService.skipSteps.push('mission');
        }
    }

    /**
     * Step
     */
    get step(): string {
        return this.byocMissionService.step;
    }

    /**
     * Processing Flag
     */
    get processing(): boolean {
        return this.byocMissionService.processing;
    }
}
